import { StandardEvents } from '@shopify/events';

// -- Constants
const COMPONENT_NAME = 'darkrim-new-product-main-component';
const VARIANT_PICKER_SELECTOR = 'variant-picker';
const SLIDESHOW_SELECTOR = 'media-gallery slideshow-component';

// -- Component
class DarkrimNewProductMainComponent extends HTMLElement {
  // -- State and variables
  /** @type {AbortController | undefined} */
  #abortController;

  // -- Functions
  /** @param {string | number} mediaId */
  #selectMedia(mediaId) {
    const slideshow = /** @type {import('./slideshow').Slideshow | null} */ (
      this.querySelector(SLIDESHOW_SELECTOR)
    );
    if (!slideshow) return;

    slideshow.select({ id: String(mediaId) }, undefined, { animate: false });
  }

  // -- Listeners
  /** @param {Event} event */
  #handleVariantChange = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.closest(VARIANT_PICKER_SELECTOR)) return;

    const mediaId = target.dataset.featuredMediaId;
    if (mediaId) this.#selectMedia(mediaId);
  };

  /** @param {import('@shopify/events').ProductSelectEvent} event */
  #handleProductSelect = (event) => {
    event.promise
      ?.then(({ detail }) => {
        const mediaId = detail?.resource?.featured_media?.id;
        if (!mediaId) return;

        requestAnimationFrame(() => this.#selectMedia(mediaId));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[darkrim-new-product-main] Variant media update failed:', error);
      });
  };

  // -- Lifecycle hooks
  connectedCallback() {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.addEventListener('change', this.#handleVariantChange, { signal });
    this.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, { signal });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }
}

// -- Registration
if (!customElements.get(COMPONENT_NAME)) {
  customElements.define(COMPONENT_NAME, DarkrimNewProductMainComponent);
}
